import React , {useState , useEffect} from 'react';

import {
    Tabs,
    TabsContent,
    TabsList,
    TabsTrigger,

} from "src/components/ui/tabs"

import { fetchSubscriptions } from '../../utilities';

import { 
    SaveMore,
    SubscriptionsPlans
 } from "../../components";


const SubscriptionsMonthlydata = {
    plans: [
        { title: 'Print Edition', description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed', price: '$7', frequency: 'per month' , btnTitle: 'Get' },
        { title: 'Digital App', description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed', price: '$5', frequency: 'per month',btnTitle: 'Get' },
        { title: 'Print + Digital', description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed', price: '$10', frequency: 'per month',btnTitle: 'Get' },
    ]
};

const SubscriptionsAnnualdata = {
    plans: [
        { title: 'Print Edition', description: 'Receive a Benedictus printed booklet in the mail each month.', price: '$79', frequency: 'per year' , btnTitle: 'Get' },
        { title: 'Digital App', description: 'Receive a Benedictus printed booklet in the mail each month.', price: '$59', frequency: 'per year',btnTitle: 'Get' },
        { title: 'Print + Digital', description: 'Receive a Benedictus printed booklet in the mail each month.', price: '$109', frequency: 'per year',btnTitle: 'Get' },
    ]
};

const YourPackagedata ={
    plans: [
        { title: 'Print + Digital', description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed', price: '$10', frequency: 'per month',btnTitle: 'Cancel', cancel:true },
    ]
}
const Subscriptions = () => {
    const [monthlyPlans, setMonthlyPlans] = useState([]);
    const [annuallyPlans , setAnnuallyPlans] = useState([])
    const [loading, setLoading] = useState(true);
   
    useEffect(() => {
        const loadMonthlyPlans = async () => {
          const data = await fetchSubscriptions();
          setLoading(true);
      
          // Filter only "monthly" plans
          const monthly = data
            .filter(item => item.attributes?.period === "month")
            .map(item => ({
              title: item.attributes?.title || "Untitled",
              description: item.attributes?.content || item.attributes?.excerpt || "",
              price: `$${item.attributes?.price || "0"}`,
              frequency: "per month",
              btnTitle: "Get",
              link: item.links?.checkout || "#",
            }));
            const annual = data
            .filter(item => item.attributes?.period === "year")
            .map(item => ({
              title: item.attributes?.title || "Untitled",
              description: item.attributes?.content || item.attributes?.excerpt || "",
              price: `$${item.attributes?.price || "0"}`,
              frequency: "per year",
              btnTitle: "Get",
              link: item.links?.checkout || "#",
            }));
      
          setMonthlyPlans(monthly);
          setAnnuallyPlans(annual);
          setLoading(false);
        };
      
        loadMonthlyPlans();
      }, []);
    return (
        <>
            <div>
                <div className="pt-8">
                    <div className="flex items-center w-full pb-5">
                        <h2 className="text-base font-medium text-primary-0 font-redhat">Subscriptions</h2>
                        <div className="relative flex-grow ml-4 border-b border-gray-100 top-2"></div>
                    </div>
                </div>
                {/*Tabs for Subscriptions */}
                <Tabs defaultValue="monthly" className="flex flex-col items-center bg-white-50">
                    <TabsList className="px-[5px] py-[22px] bg-gold-200 text-gray-0 rounded-[50px]">
                        <div className="flex flex-row w-fit md:items-center">
                            {[
                                { value: "monthly", label: "Monthly" , show:true },
                                { value: "annual", label: "Annual" , show :annuallyPlans?.plans?.length>0 },
                            ].filter(tab=>tab.show)
                            .map((tab) => (
                                <TabsTrigger
                                    key={tab.value}
                                    value={tab.value}
                                    className=" text-gray-0 text-sm font-medium cursor-pointer font-redhat !shadow-none  data-[state=active]:text-gold-500 data-[state=active]:bg-gray-0 data-[state=active]:rounded-[70px]"
                                >
                                    {tab.label}

                                </TabsTrigger>
                            ))}
                        </div>
                    </TabsList>


                    <TabsContent value="monthly" className="w-full max-w-full">
                        <div className="flex flex-row w-full overflow-x-auto md:items-center scrollbar-hide xl:overflow-visible">
                            <div className="flex flex-shrink-0 xl:shrink gap-6 pt-4">
                               <SubscriptionsPlans data={{ plans: monthlyPlans }} loading={loading}/>                               
                            </div>
                        </div>
                    </TabsContent>
                    {
                        annuallyPlans?.plans?.length>0 && (
                            <TabsContent value="annual" className="w-full max-w-full">
                            <div className="flex flex-row w-full overflow-x-auto md:items-center scrollbar-hide xl:overflow-visible">
                                <div className="flex flex-shrink-0 xl:shrink gap-6 pt-4">
                                   <SubscriptionsPlans data={{plans:annuallyPlans}} loading={loading}/>                               
                                </div>
                            </div>
                        </TabsContent>
                        )
                    }
                   
                </Tabs>
            </div>

            <div className="pt-8">
                <div className="flex items-center w-full pb-5">
                    <h2 className="text-base font-medium text-primary-0 font-redhat">Your Package</h2>
                    <div className="relative flex-grow ml-4 border-b border-gray-100 top-2"></div>
                </div>

                <div class="flex flex-row w-full overflow-x-auto md:items-center scrollbar-hide xl:overflow-visible">
                    <div className="flex flex-shrink-0 xl:shrink gap-6 pt-4">
                        <SubscriptionsPlans data={YourPackagedata}/>                               
                    </div>
                </div>
              
            </div>

            <div className="pt-8 pb-10">
                <div className="flex items-center w-full pb-5">
                    <h2 className="text-base font-medium text-primary-0 font-redhat">Other Packages</h2>
                    <div className="relative flex-grow ml-4 border-b border-gray-100 top-2"></div>
                </div>

                {/*Tabs for Subscriptions */}
                <Tabs defaultValue="monthly" className="flex flex-col items-center bg-white-50">
                    <TabsList className="px-[5px] py-[22px] bg-gold-200 text-gray-0 rounded-[50px]">
                        <div className="flex flex-row w-fit md:items-center">
                            {[
                                { value: "monthly", label: "Monthly" },
                                { value: "annual", label: "Annual" },
                            ].map((tab) => (
                                <TabsTrigger
                                    key={tab.value}
                                    value={tab.value}
                                    className=" text-gray-0 text-sm font-medium cursor-pointer font-redhat !shadow-none  data-[state=active]:text-gold-500 data-[state=active]:bg-gray-0 data-[state=active]:rounded-[70px]"
                                >
                                    {tab.label}

                                </TabsTrigger>
                            ))}
                        </div>
                    </TabsList>


                    <TabsContent value="monthly" className="w-full max-w-full">
                        <div class="flex flex-row w-full overflow-x-auto md:items-center scrollbar-hide xl:overflow-visible">
                            <div className="flex flex-shrink-0 xl:shrink gap-6 pt-4">
                               <SubscriptionsPlans data={SubscriptionsMonthlydata}/>                               
                            </div>
                        </div>
                    </TabsContent>
                    <TabsContent value="annual" className="w-full max-w-full">
                        <div class="flex flex-row w-full overflow-x-auto md:items-center scrollbar-hide xl:overflow-visible">
                            <div className="flex flex-shrink-0 xl:shrink gap-6 pt-4">
                               <SubscriptionsPlans data={SubscriptionsAnnualdata}/>                               
                            </div>
                        </div>
                    </TabsContent>
                </Tabs>
            </div>
        </>
    )
}

export default Subscriptions;